module.exports = __webpack_public_path__ + "img/olive-branch-left.e41acb64.svg";